import { Component, OnInit } from '@angular/core';
import { EmailIntegrationService } from '../_services/email-integration.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
  selector: 'app-email-campaign',
  templateUrl: './email-campaign.component.html',
  styleUrls: ['./email-campaign.component.scss']
})
export class EmailCampaignComponent implements OnInit {

  constructor(private emailintegrationservice: EmailIntegrationService, private router: Router, private _localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.emailintegrationservice.fetchintegratedemails().subscribe((res: any)=>{
      if(res.integratedemailsarray && !res.integratedemailsarray.length){
        this.router.navigate(['email-campaign/connect']);
      }
    })
  }

}
